export const DATA = [


    {
        id: '1',
        title: '玉米期货交易指南',
        des: '大连商品交易所投资者教育资料 ——玉米期货交易指南',
        category: '品种交易指南',
        img: 'cornA.jpg',
        url: 'http://www.heremay.com/DCE/cornA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '2',
        title: '玉米期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——玉米期货产品与服务指南',
        category: '产品与服务指南',
        img: 'cornB.jpg',
        url: 'http://www.heremay.com/DCE/cornB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '3',
        title: '苯乙烯期货交易指南',
        des: '大连商品交易所投资者教育资料 ——苯乙烯期货交易指南',
        category: '品种交易指南',
        img: 'EBA.jpg',
        url: 'http://www.heremay.com/DCE/EBA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '4',
        title: '苯乙烯期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——苯乙烯期货产品与服务指南',
        category: '产品与服务指南',
        img: 'EBB.jpg',
        url: 'http://www.heremay.com/DCE/EBB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '5',
        title: '豆粕期货交易指南',
        des: '大连商品交易所投资者教育资料 ——豆粕期货交易指南',
        category: '品种交易指南',
        img: 'soybeanmealA.jpg',
        url: 'http://www.heremay.com/DCE/soybeanmealA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '6',
        title: '豆粕期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——豆粕期货产品与服务指南',
        category: '产品与服务指南',
        img: 'soybeanmealB.jpg',
        url: 'http://www.heremay.com/DCE/soybeanmealB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '7',
        title: '豆油期货交易指南',
        des: '大连商品交易所投资者教育资料 ——豆油期货交易指南',
        category: '品种交易指南',
        img: 'soybeanoilA.jpg',
        url: 'http://www.heremay.com/DCE/soybeanoilA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '8',
        title: '豆油期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——豆油期货产品与服务指南',
        category: '产品与服务指南',
        img: 'soybeanoilB.jpg',
        url: 'http://www.heremay.com/DCE/soybeanoilB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '9',
        title: '黄大豆期货交易指南',
        des: '大连商品交易所投资者教育资料 ——黄大豆期货交易指南',
        category: '品种交易指南',
        img: 'soybeanA.jpg',
        url: 'http://www.heremay.com/DCE/soybeanA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '10',
        title: '黄大豆期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——黄大豆期货产品与服务指南',
        category: '产品与服务指南',
        img: 'soybeanB.jpg',
        url: 'http://www.heremay.com/DCE/soybeanB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '11',
        title: '鸡蛋期货交易指南',
        des: '大连商品交易所投资者教育资料 ——鸡蛋期货交易指南',
        category: '品种交易指南',
        img: 'eggA.jpg',
        url: 'http://www.heremay.com/DCE/eggA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '12',
        title: '鸡蛋期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——鸡蛋期货产品与服务指南',
        category: '产品与服务指南',
        img: 'eggB.jpg',
        url: 'http://www.heremay.com/DCE/eggB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '13',
        title: '焦煤期货交易指南',
        des: '大连商品交易所投资者教育资料 ——焦煤期货交易指南',
        category: '品种交易指南',
        img: 'cokingcoalA.jpg',
        url: 'http://www.heremay.com/DCE/cokingcoalA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '14',
        title: '焦煤期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——焦煤期货产品与服务指南',
        category: '产品与服务指南',
        img: 'cokingcoalB.jpg',
        url: 'http://www.heremay.com/DCE/cokingcoalB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '15',
        title: '焦炭期货交易指南',
        des: '大连商品交易所投资者教育资料 ——焦炭期货交易指南',
        category: '品种交易指南',
        img: 'cokeA.jpg',
        url: 'http://www.heremay.com/DCE/cokeA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '16',
        title: '焦炭期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——焦炭期货产品与服务指南',
        category: '产品与服务指南',
        img: 'cokeB.jpg',
        url: 'http://www.heremay.com/DCE/cokeB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '17',
        title: '粳米期货交易指南',
        des: '大连商品交易所投资者教育资料 ——粳米期货交易指南',
        category: '品种交易指南',
        img: 'riceA.jpg',
        url: 'http://www.heremay.com/DCE/riceA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '18',
        title: '粳米期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——粳米期货产品与服务指南',
        category: '产品与服务指南',
        img: 'riceB.jpg',
        url: 'http://www.heremay.com/DCE/riceB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '19',
        title: '聚丙烯期货交易指南',
        des: '大连商品交易所投资者教育资料 ——聚丙烯期货交易指南',
        category: '品种交易指南',
        img: 'ppA.jpg',
        url: 'http://www.heremay.com/DCE/ppA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '20',
        title: '聚丙烯期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——聚丙烯期货产品与服务指南',
        category: '产品与服务指南',
        img: 'ppB.jpg',
        url: 'http://www.heremay.com/DCE/ppB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '21',
        title: '聚氯乙烯期货交易指南',
        des: '大连商品交易所投资者教育资料 ——聚氯乙烯期货交易指南',
        category: '品种交易指南',
        img: 'pvcA.jpg',
        url: 'http://www.heremay.com/DCE/pvcA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '22',
        title: '聚氯乙烯期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——聚氯乙烯期货产品与服务指南',
        category: '产品与服务指南',
        img: 'pvcB.jpg',
        url: 'http://www.heremay.com/DCE/pvcB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '23',
        title: '线型低密度聚乙烯期货交易指南',
        des: '大连商品交易所投资者教育资料 ——线型低密度聚乙烯期货交易指南',
        category: '品种交易指南',
        img: 'lldpeA.jpg',
        url: 'http://www.heremay.com/DCE/lldpeA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '24',
        title: '线型低密度聚乙烯期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——线型低密度聚乙烯期货产品与服务指南',
        category: '产品与服务指南',
        img: 'lldpeB.jpg',
        url: 'http://www.heremay.com/DCE/lldpeB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '25',
        title: '铁矿石期货交易指南',
        des: '大连商品交易所投资者教育资料 ——铁矿石期货交易指南',
        category: '品种交易指南',
        img: 'ironoreA.jpg',
        url: 'http://www.heremay.com/DCE/ironoreA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '26',
        title: '铁矿石期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——铁矿石期货产品与服务指南',
        category: '产品与服务指南',
        img: 'ironoreB.jpg',
        url: 'http://www.heremay.com/DCE/ironoreB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '27',
        title: '液化石油气期货交易指南',
        des: '大连商品交易所投资者教育资料 ——液化石油气期货交易指南',
        category: '品种交易指南',
        img: 'lpgA.jpg',
        url: 'http://www.heremay.com/DCE/lpgA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '28',
        title: '液化石油气期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——液化石油气期货产品与服务指南',
        category: '产品与服务指南',
        img: 'lpgB.jpg',
        url: 'http://www.heremay.com/DCE/lpgB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '29',
        title: '乙二醇期货交易指南',
        des: '大连商品交易所投资者教育资料 ——乙二醇期货交易指南',
        category: '品种交易指南',
        img: 'EGA.jpg',
        url: 'http://www.heremay.com/DCE/EGA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '30',
        title: '乙二醇期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——乙二醇期货产品与服务指南',
        category: '产品与服务指南',
        img: 'EGB.jpg',
        url: 'http://www.heremay.com/DCE/EGB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '31',
        title: '玉米淀粉期货交易指南',
        des: '大连商品交易所投资者教育资料 ——玉米淀粉期货交易指南',
        category: '品种交易指南',
        img: 'cornstarchA.jpg',
        url: 'http://www.heremay.com/DCE/cornstarchA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '32',
        title: '玉米淀粉期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——玉米淀粉期货产品与服务指南',
        category: '产品与服务指南',
        img: 'cornstarchB.jpg',
        url: 'http://www.heremay.com/DCE/cornstarchB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '33',
        title: '棕榈油期货交易指南',
        des: '大连商品交易所投资者教育资料 ——棕榈油期货交易指南',
        category: '品种交易指南',
        img: 'rmdpalmA.jpg',
        url: 'http://www.heremay.com/DCE/rmdpalmA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '34',
        title: '棕榈油期货产品与服务指南',
        des: '大连商品交易所投资者教育资料 ——棕榈油期货产品与服务指南',
        category: '产品与服务指南',
        img: 'rmdpalmB.jpg',
        url: 'http://www.heremay.com/DCE/rmdpalmB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '35',
        title: '生猪期货交易指南',
        des: '大连商品交易所投资者教育资料 ——生猪期货交易指南',
        category: '品种交易指南',
        img: 'hogA.jpg',
        url: 'http://www.heremay.com/DCE/hogA/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '36',
        title: '生猪期货合约规则设计报告',
        des: '大连商品交易所投资者教育资料 ——生猪期货合约规则设计报告',
        category: '合约规则设计报告',
        img: 'hogB.jpg',
        url: 'http://www.heremay.com/DCE/hogB/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '37',
        title: '生猪期货60问',
        des: '大连商品交易所投资者教育资料 ',
        category: '品种问答',
        img: 'hog60.jpg',
        url: 'http://www.heremay.com/DCE/hog60/mobile/index.html',
        date: '2021-08-10'
    },
    {
        id: '38',
        title: '生猪期货交割服务手册',
        des: '大连商品交易所投资者教育资料 ——生猪期货交割服务手册',
        category: '产品与服务指南',
        img: 'hogC.jpg',
        url: 'http://www.heremay.com/DCE/hogC/mobile/index.html',
        date: '2021-08-10'
    }
]